import React, { useState, useEffect } from "react";
import axios from "axios";
import Layout from "../Layout/Layout";
import { useCountry } from "../../context/country";

export default function ChangeCountry() {
  const [country, setCountry] = useCountry();

  const [selectedCurrency, setSelectedCurrency] = useState(() => {
    const cached = JSON.parse(sessionStorage.getItem("country_data"));
    return cached?.code || "INR";
  });

  const countryPresets = {
    INR: {
      country_code: "IN",
      calling_code: "+91",
      code: "INR",
      currency_name: "INR",
      country_name: "India",
    },
    USD: {
      country_code: "US",
      calling_code: "+1",
      code: "USD",
      currency_name: "Dollar",
      country_name: "United States",
    },
    AED: {
      country_code: "AE",
      calling_code: "+971",
      code: "AED",
      currency_name: "Dirham",
      country_name: "United Arab Emirates",
    },
  };

  const ipMap = {
    INR: null,
    USD: "8.8.8.8",
    AED: "83.110.250.231",
  };

  useEffect(() => {
    const cached = JSON.parse(sessionStorage.getItem("country_data"));

    if (cached) {
      setCountry(cached);
      setSelectedCurrency(cached.code);
    }
  }, []);

  const getCurrencyInfo = async (code) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/cart/exchange-currency`,
        {
          params: { code },
        }
      );

      sessionStorage.setItem(
        "country_currency",
        JSON.stringify(data)
      );
    } catch (err) {
      console.error(err);
    }
  };

  const handleCountryChange = async (e) => {
    const code = e.target.value;

    setSelectedCurrency(code);

    const preset = countryPresets[code];

    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/ip-details`,
        {
          params: {
            ip: ipMap[code],
          },
        }
      );

      const countryData = {
        country_code:
          preset?.country_code || data?.country_code,

        calling_code:
          preset?.calling_code || data?.country_calling_code,

        code: preset?.code || data?.currency,

        currency_name:
          preset?.currency_name || data?.currency_name,

        country_name:
          preset?.country_name || data?.country_name,

        languages: data?.languages
          ? data.languages.split(",")[0]
          : null,

        latitude: data?.latitude || null,
        longitude: data?.longitude || null,
        city: data?.city || null,
        region: data?.region || null,

        status: true,
      };

      setCountry(countryData);

      sessionStorage.setItem(
        "country_data",
        JSON.stringify(countryData)
      );

      sessionStorage.setItem("manual_country", "true");

      setCountry(countryData);

      sessionStorage.removeItem("country_currency");

      await getCurrencyInfo(code);

      window.location.reload();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Layout
      title="Change Country : Chaashni By MK"
      description="Chaashni Couture"
    >
      <div className="online-appointment-banner">
        <span>Change Country</span>
      </div>

      <div className="site-content-wrap static-page change-country-page">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="content-box">
                <div className="country-dropdown">
                  <label>Change Currency</label>

                  <select
                    id="currency"
                    name="currency"
                    className="currency-select"
                    value={selectedCurrency}
                    onChange={handleCountryChange}
                  >
                    <option value="INR">₹ INR</option>
                    <option value="USD">$ USD</option>
                    <option value="AED">د.إ AED</option>
                  </select>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}